import { render, staticRenderFns } from "./ModalGroupTypeEdit.vue?vue&type=template&id=0ce8f4b8&scoped=true"
import script from "./ModalGroupTypeEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupTypeEdit.vue?vue&type=style&index=0&id=0ce8f4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce8f4b8",
  null
  
)

export default component.exports